<template>
  <el-container id="app">
    <Header></Header>
    <router-view></router-view>
  </el-container>
</template>

<script>

import Header from "@/components/header";

export default {
  name: 'App',
  components: {
    Header
  }
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
}
</style>